declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';

import { ApiResponseModel } from '../../../src/app/ncs/models/api_response_model';
import { ApiRequestModel } from '../../../src/app/ncs/models/api_request_model';
import { SpinnerService } from '../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../src/app/ncs/models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { xLoginResponse } from '../../../src/app/ncs/models/login/loginresponsemodel';
import { LoginRequest, AppUserSettingRequest, AppUserSettingInfoController } from '../../../src/app/ncs/models/login/loginrequestmodel';
import { NGXToastrService } from '../../../src/app/shared/services/toastr.service';
import { LoginService } from '../../../src/app/ncs/services/login.service';
import { HCPService } from '../../../src/app/ncs/services/hcp.service';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController }
  from '../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../src/app/ncs/models/actor/actor';

import * as alertFunctions from '../../../src/app/shared/data/sweet-alerts';

//import sha1Hex from 'sha1-hex';

//import MD5 from 'src/app/shared/utils/md5';
import { ForgotPasswordRequest } from '../../../src/app/ncs/models/login/forgotpassword.model';
import { ChangePasswordRequest } from '../../../src/app/ncs/models/login/changepassword.model';
import { ResendOTPRequest, ConfirmOTPRequest } from '../../../src/app/ncs/models/comm/resendotprequest.model';
import { UserActivationService } from '../../../src/app/ncs/services/useractivation.service';
import MD5 from 'src/app/shared/utils/md5';

@Component({
  selector: 'forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
  //styleUrls: ['./rncloudstartup.component.scss']
})

export class ForGotPasswordComponent implements OnInit {

  @ViewChild('f') forogtPasswordForm: NgForm;

  public UserName: string;
  CurrentForgotPasswordRequest: ForgotPasswordRequest;
  CurrentChangePasswordRequest: ChangePasswordRequest;

  CurrentResendOTPRequest: ResendOTPRequest;
  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel;

  public ForgetPasswordStep: number = 0;
  public OTPActivationRequestCode: number;
  CurrentConfirmOTPRequest: ConfirmOTPRequest;

  constructor( private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute,
    private UserActivationService: UserActivationService, private tosterservice: NGXToastrService) { }
  UserName2: string;
  ngOnInit() {
   this.UserName2 = AppData.Instance().UserLoginDetails.DisplayName;
    localStorage.clear();
    this.CurrentForgotPasswordRequest = new ForgotPasswordRequest();
    this.CurrentForgotPasswordRequest.RequestMode = 'WEB';
    this.CurrentForgotPasswordRequest.RequestType = 1;

    this.CurrentResendOTPRequest = new ResendOTPRequest();
    this.CurrentConfirmOTPRequest = new ConfirmOTPRequest();

    this.CurrentChangePasswordRequest = new ChangePasswordRequest();


  }


  // On submit click, reset form fields
  onSubmit() {
    //alertFunctions.AlertParam('hi....!');
    this.StartRefreshing();
    this.UserActivationService.xForgetPassword(this.CurrentForgotPasswordRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          // alertFunctions.ShowSuccess('Transaction Password Sent', 'A Transaction password is sent to your registered Email ID, please confirm.');
          // alertFunctions.ShowSuccess('Transaction Password Sent', 'A Transaction password is sent to your registered Email ID, please confirm.');
          //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Transaction Password Sent', 'A Transaction password is sent to your registered Email ID, please confirm.');

          //console.log('parseInt(this.ApiResData.Result)-->' + parseInt(this.ApiResData.Result));
          this.OTPActivationRequestCode = parseInt(this.ApiResData.Result)
          this.CurrentResendOTPRequest.ActorOTPRequestCode = this.OTPActivationRequestCode;
          this.CurrentConfirmOTPRequest.ActorOTPRequestCode = this.OTPActivationRequestCode;
          this.CurrentChangePasswordRequest.UserName = this.CurrentForgotPasswordRequest.UserName;

          this.ForgetPasswordStep = 1;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );
    // this.forogtPasswordForm.reset();
  }


  onResendOTP() {

    this.StartRefreshing();

    this.UserActivationService.xReSendOTPToActorOTPRequest(this.CurrentResendOTPRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          // alertFunctions.ShowSuccess('Transaction Password Sent', 'A transaction password is resent to your registered Email ID');

          this.tosterservice.ToasterSuccessAlertParam('Transaction Password Sent', 'A transaction password is resent to your registered Email ID');


          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            if (this.ApiResData.hasRedirectPage) {
              this.ForgetPasswordStep = 0;

            }
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }

        }


      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  onOTPSubmit() {
    this.StartRefreshing();

    this.UserActivationService.xConfirmOTPToActorOTPRequest(this.CurrentResendOTPRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          // alertFunctions.AlertParam("OTP Success...!");
          // alertFunctions.ShowSuccess('Transaction Code Matched', ' Please reset your password now.');
          this.tosterservice.ToasterSuccessAlertParam('Transaction Code Matched', ' Please reset your password now.');

          this.stopRefreshing();

          this.ForgetPasswordStep = 2;
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }

        }


      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );


  }


  onChangePassword() {

    // cheking if passord and reenter passsword are same..
    if (this.CurrentChangePasswordRequest.NewPassword === this.CurrentChangePasswordRequest.ReEnterPassword) {

      this.StartRefreshing();

      if (AppData.IsEncriptFromClientSide == true) {
        this.CurrentChangePasswordRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
        //this.CurrentChangePasswordRequest.OldPassword
          //this.CurrentForgotPasswordRequest.UserName;
        this.CurrentChangePasswordRequest.ConditionalOperator = 99;
        this.CurrentChangePasswordRequest.OldPassword = MD5(this.CurrentChangePasswordRequest.OldPassword);
        this.CurrentChangePasswordRequest.NewPassword = MD5(this.CurrentChangePasswordRequest.NewPassword); // MD5..
        // SHA1
        // SHA1 + MD5
        // SHA1 + MD5 + BAse 64
        this.CurrentChangePasswordRequest.ReEnterPassword = MD5 (this.CurrentChangePasswordRequest.ReEnterPassword);
        this.CurrentChangePasswordRequest.IsEncriptFromClient = true;
        this.CurrentChangePasswordRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      }

      this.UserActivationService.xChangePassword(this.CurrentChangePasswordRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

          //  this.activeModal.close();

            // alertFunctions.AlertParam("Change Password Successfully...!");
            alertFunctions.ShowSuccess('Password Changed', ' Your password changed successfully. You may sign in with your credentials.');
            this.stopRefreshing();
            this.router.navigate(['signinpage']);

            this.ForgetPasswordStep = 3;
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.AlertParam('Change Password Failed Due to Internal Error.... Please Contact Admin..');
            }

          }


        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


        );
    }
    else {
      alertFunctions.AlertParamEr('Password  mismatch With ReEntered Password ');
    }



  }

  // On login link click
  onLogin() {
    this.router.navigate(['signinpage']);
  }

  // On registration link click
  onRegister() {
    this.router.navigate(['signuppage']);
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }






}
